export function isFloatLocal(val) {
    const floatRegex = /^-?\d+(\.\d+)?$/;
    if (!val || typeof val !== 'string') return false;
    if (!floatRegex.test(val.replace(',', '.')))
        return false;

    return !isNaN(parseFloat(val));
}

export function getMasterValueForField(fieldName, masterDefinitions, selectedInspectionPoint) {
    // Gleiche Masterwert-Auswahl wie bisher in InspectionPointView.getCompareColor.
    const hasMasterVal = masterDefinitions &&
        masterDefinitions[fieldName] !== undefined &&
        masterDefinitions[fieldName] !== null &&
        masterDefinitions[fieldName] !== '' &&
        Object.keys(masterDefinitions).length > 0;

    return hasMasterVal
        ? masterDefinitions[fieldName]
        : (selectedInspectionPoint ? selectedInspectionPoint[fieldName] : '');
}

export function getCompareColorForField({
    fieldName,
    measurement,
    masterDefinitions,
    selectedInspectionPoint,
    isUebenChecked,
    routeName
}) {
    if (!isUebenChecked && routeName !== 'EvaluationDetail') return '';

    if (measurement[fieldName] === undefined || measurement[fieldName] === null || measurement[fieldName] === '') return '';

    const userValRaw = measurement[fieldName];
    const userValue = String(userValRaw).replace(',', '.');

    // Als Vergleichswert (Master) nutzen wir primär die masterDefinitions,
    // falls diese leer sind, nehmen wir die Vorgabe (selectedInspectionPoint).
    // WICHTIG: 0 ist ein gültiger Wert, den der Ausbilder eingeben kann!
    const masterValRaw = getMasterValueForField(fieldName, masterDefinitions, selectedInspectionPoint);

    const masterValue = String(masterValRaw !== undefined && masterValRaw !== null ? masterValRaw : '').replace(',', '.');

    if (isFloatLocal(userValue) && isFloatLocal(masterValue)) {
        if (parseFloat(userValue) === parseFloat(masterValue)) {
            return 'green';
        }
    } else if (userValue === masterValue) {
        return 'green';
    }

    return 'red';
}
